import React from "react";
import { useTranslation } from "react-i18next";
import useHelper from "../../components/_common/useHelper";

import Carousel from "react-material-ui-carousel";

import { Container, IconButton } from "@material-ui/core";
import { PauseCircleOutline, PlayCircleOutline } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";

import AccessibilityTooltip from "../../components/_common/AccessibilityTooltip";

const useStyles = makeStyles((theme) => ({
    bannerContainer: {
        padding: 0,
        marginTop: 0, //64,
        position: "relative",
        maxWidth: 1472,
        [theme.breakpoints.down("sm")]: {
            // margin: theme.spacing(0, -2),
            margin: theme.spacing(0, -0),
            width: "100%",
        },
    },
    bannerCarousel: {
        "& div:has(picture)": {
            opacity: 1,
        },
    },
    bannerPicture: {
        marginTop: 0, //theme.spacing(13),
        width: "100%",
        minHeight: 296,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#d1e4f2",
        color: "#FFFFFF",
        "& img": {
            // width: "100%!important",
        },
        [theme.breakpoints.down("sm")]: {
            // marginTop: theme.spacing(18),
            minWidth: "100vw",
            minHeight: "unset",
            "& img": {
                width: "100%",
            },
        },
    },
    bannerImg: {
        marginTop: theme.spacing(13),
        width: "100%",
        minHeight: 296,
        [theme.breakpoints.down("sm")]: {
            marginTop: theme.spacing(18),
            minWidth: 556,
            minHeight: "unset",
        },
    },
    bannerDiv: {
        minHeight: 200,
        marginTop: theme.spacing(18),
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(0, 4),
        // fontSize: "80%",
        fontSize: "clamp(11px, 10vw, 12px)",
        lineHeight: 1.25,
        [theme.breakpoints.down("sm")]: {
            marginTop: 0,
            minHeight: 120,
        },
    },
    buttonWrapper: {
        "&:focus-within": {
            "& button": {
                opacity: 1,
                outlineOffset: 2, //3,
                outlineColor: "#101010",
                outlineStyle: "solid",
                outlineWidth: 2,
            },
        },
    },
    navButton: {
        display: "none!important",
    },
    indicatorContainer: {
        paddingBottom: 16,
        marginTop: "3px!important",
        [theme.breakpoints.down("sm")]: {
            paddingBottom: 0,
        },
    },
    indicator: {
        width: 24,
        height: 24,
        " & svg": {
            fontSize: 18,
        },
        "&:focus-visible": {
            outlineOffset: 2,
            outlineColor: "#101010",
            outlineStyle: "solid",
            outlineWidth: 2,
        },
    },
    indicatorActive: {
        "& svg": {
            color: theme.palette.primary.main,
        },
    },
    btnContainer: {
        padding: 0,
        marginTop: 0,
        position: "relative",
        display: "flex",
        justifyContent: "flex-end",
        maxWidth: 1472,
    },
    playBtn: {
        boxShadow: "none",
        "& svg": {
            fontSize: 24,
        },
        // marginTop: -40,
        // position: "absolute",
        // right: 0,
        "&:focus-visible": {
            outlineOffset: 2,
            outlineColor: "#101010",
            outlineStyle: "solid",
            outlineWidth: 2,
        },
    },
}));

const Banner = ({ isMobile }) => {
    const classes = useStyles();
    const { i18n, t } = useTranslation();
    const { translationFromJson } = useHelper();

    const [autoPlay, setAutoPlay] = React.useState(true);

    const handleAutoPlay = () => {
        setAutoPlay(!autoPlay);
    };

    const bannerInfos = [
        {
            url: `/${i18n.language}/banners/banner01.jpg`,
            alt: "Repozytorium Systemów Informacyjnych jest bazą wiedzy, obejmującą metadane o systemach informacyjnych administracji publicznej",
            alt_en: "Information Systems Repository (RSI) is a knowledge base comprising metadata about official registers and public administration information systems",
            html: `<b style="margin-bottom: 8px; display: block;">Repozytorium<br/>Systemów Informacyjnych</b> jest bazą wiedzy, obejmującą metadane o systemach informacyjnych administracji publicznej`,
            html_en: `
            <b style="margin-bottom: 8px; display: block;">Information Systems Repository (RSI) </b> is a knowledge base comprising metadata about official registers and public administration information systems`,
            bgColor: "#1977BD",
            language: ["pl", "en"],
        },
        {
            url: `/${i18n.language}/banners/banner02.jpg`,
            alt: "Certyfikat innowacyjnej praktyki Forum Zarządzania Publicznego W IV edycji konkursu Forum Zarządzania Publicznego, Główny Urząd Statystyczny otrzymał za Repozytorium Systemów Informacyjnych (RSI) Certyfikat innowacyjnej praktyki",
            alt_en: "Public Management Forum Innovative Practice Certificate In the 4th edition of the Public Management Forum competition, Statistics Poland received a Certificate of Innovative Practice for Information Systems Repository (RSI)",
            html: `<b style="margin-bottom: 8px; display: block;">Certyfikat innowacyjnej praktyki Forum Zarządzania Publicznego </b> W IV edycji konkursu Forum Zarządzania Publicznego, Główny Urząd Statystyczny otrzymał za Repozytorium Systemów Informacyjnych (RSI) Certyfikat innowacyjnej praktyki`,
            html_en: `
            <b style="margin-bottom: 8px; display: block;">Public Management Forum Innovative Practice Certificate</b> In the 4th edition of the Public Management Forum competition, Statistics Poland received a Certificate of Innovative Practice for Information Systems Repository (RSI)`,
            bgColor: "#001D77",
            language: ["pl", "en"],
        },
        {
            url: `/${i18n.language}/banners/banner03.jpg`,
            alt: "Prowadzona jest w RSI kompleksowa aktualizacja opisów systemów i rejestrów",
            alt_en: "Comprehensive update of the descriptions of systems and registries in Information Systems Repository (RSI) is currently underway",
            html: `<b style="margin-bottom: 8px; display: block;">Prowadzona jest w RSI kompleksowa aktualizacja opisów systemów i rejestrów</b>`,
            html_en: `<b style="margin-bottom: 8px; display: block;">Comprehensive update of the descriptions of systems and registries in Information Systems Repository (RSI) is currently underway</b>`,
            bgColor: "#001D77",
            language: ["pl", "en"],
        },
        {
            url: `/${i18n.language}/banners/banner04.jpg`,
            alt: "Zmiana nazwy",
            alt_en: "Name change",
            html: `<b style="margin-bottom: 8px; display: block;">Nazwa Repozytorium Standardów Informacyjnych uległa zmianie na: Repozytorium Systemów Informacyjnych</b>`,
            html_en: `<b style="margin-bottom: 8px; display: block;">The name of the Information Standards Repository has been changed to: Information Systems Repository</b>`,
            bgColor: "#001D77",
            language: ["pl"],
        },
    ];

    return (
        <React.Fragment>
            <Container maxWidth={"lg"} className={classes.bannerContainer}>
                <Carousel
                    navButtonsWrapperProps={{ className: classes.buttonWrapper }}
                    navButtonsProps={{ className: classes.navButton, tabIndex: -1 }}
                    indicatorContainerProps={{ className: classes.indicatorContainer }}
                    indicatorIconButtonProps={{
                        className: classes.indicator,
                        tabIndex: 0,
                        "aria-label": t("Przełącz na slajd nr{{dot}}", { dot: "." }),
                    }}
                    activeIndicatorIconButtonProps={{
                        className: classes.indicatorActive,
                    }}
                    autoPlay={autoPlay}
                    className={classes.bannerCarousel}
                >
                    {bannerInfos
                        ?.filter((info) => info?.language?.includes(i18n?.language))
                        ?.map((banner, i) => {
                            const { url, bgColor } = banner;
                            const alt = translationFromJson(banner, "alt");
                            const html = translationFromJson(banner, "html");
                            return isMobile ? (
                                <div key={i} className={classes.bannerDiv} style={{ backgroundColor: bgColor }}>
                                    <span dangerouslySetInnerHTML={{ __html: html }} />
                                </div>
                            ) : (
                                <picture key={i} className={classes.bannerPicture} style={{ backgroundColor: bgColor }}>
                                    <img
                                        src={url}
                                        alt={alt?.length > 100 ? `${alt?.slice(0, 95)}...` : alt}
                                        onError={(e) =>
                                            (e.target.style = `text-align: center; width: 50%; font-style: italic; background-color: ${bgColor}`)
                                        }
                                        onLoad={(e) => (e.target.style = ``)}
                                    />
                                </picture>
                            );
                        })}
                </Carousel>
            </Container>

            <Container maxWidth={"lg"} className={classes.btnContainer}>
                <div style={{ marginTop: isMobile ? -28 : -44, marginRight: isMobile ? 0 : -3 }}>
                    <AccessibilityTooltip
                        arrow={false}
                        placement="top"
                        title={autoPlay ? t(`Wyłącz automatyczne przewijanie`) : t(`Włącz automatyczne przewijanie`)}
                        style={{ marginBottom: 32 }}
                    >
                        <IconButton
                            onClick={handleAutoPlay}
                            size={"small"}
                            color={"primary"}
                            className={classes.playBtn}
                            disableRipple
                            component={"div"}
                            aria-label={"button-to-change-automatic-scrolling"}
                        >
                            {/* {autoPlay ? <Pause fontSize={"small"} /> : <PlayArrow fontSize={"small"} />} */}
                            {autoPlay ? (
                                <PauseCircleOutline fontSize={"small"} />
                            ) : (
                                <PlayCircleOutline fontSize={"small"} />
                            )}
                        </IconButton>
                    </AccessibilityTooltip>
                </div>
            </Container>
        </React.Fragment>
    );
};

export default Banner;
